
import React from 'react'
import FullPageSpinner from '../utils/FullPageSpinner'
import { isNewFlowModal } from 'utils/flow'
import { FlowModal } from 'components/modal'
import { isMainView } from 'utils/server-data'

function ModalShell() {
  if (isMainView()) {
    return <FullPageSpinner mainPage noBackground />
  }

  return isNewFlowModal() ? (
    <FlowModal>
      <FullPageSpinner />
    </FlowModal>
  ) : (
    <FullPageSpinner oldFlowModal />
  )
}

export default ModalShell
/* eslint i18n-scan/no-inline-content: 0 */
